import { type ReactNode } from 'react';
import { clsx } from 'clsx';
import styles from './BlockTitle.scss';

interface BlockTitleProps {
  children: ReactNode;
  className?: string;
}

const BlockTitle = ({ children, className }: BlockTitleProps) => (
  <h2 className={clsx(styles.blockTitle, className)}>{children}</h2>
);

export default BlockTitle;
